module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (24).417bee7d.jpg";